//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    tableClass: {
      type: String,
      default: 'table-desktop'
    },
    isComparison: {
      type: Boolean,
      default: false
    },
    pdms: Array
  }
}
